import { MapPinIcon as LocationMarkerIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { isFuture } from 'date-fns';
import * as format from '../formatters';
import { FuneralServiceEvent, Organization } from '../types';

const ServiceLocation = ({ event }) => {
  if (!event.venue) return null;
  const { address, name } = event.venue;
  const link = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <div>
      <a href={link} target="_blank" className="text-accent-color absolute top-[50%] z-20 -translate-y-[50%] text-2xl">
        {name}
      </a>
    </div>
  );
};

const ServiceStartTime = ({ event, organization }) => {
  return (
    <div className="item service-start-time">
      <div>
        {isFuture(new Date(event!.start_at))
          ? format.dateTimeDisplayFuture(organization!.timezone, event!.start_at)
          : format.dateTimeDisplay(organization!.timezone, event!.start_at)}
      </div>
    </div>
  );
};

const Event = ({ event, organization }: { event: FuneralServiceEvent; organization: Organization | undefined }) => {
  return (
    <div className="vertical-list-service-event">
      <strong>{event.name}</strong>
      {!event.is_venue_hidden ? (
        <div className="vertical-list-service-location">
          {event.is_streamed ? <VideoCameraIcon className="event-icon" /> : <LocationMarkerIcon className="event-icon" />}
          <ServiceLocation event={event} />
        </div>
      ) : null}
      {!event.is_date_hidden ? <ServiceStartTime event={event} organization={organization} /> : null}
    </div>
  );
};

const VerticalListServiceEvents = ({
  events,
  organization,
}: {
  events: FuneralServiceEvent[] | null | undefined;
  organization: Organization | undefined;
}) => <div className="list-service-events"> {events?.map((event) => <Event key={event.name} event={event} organization={organization} />)}</div>;

export default VerticalListServiceEvents;
